<template>
  <footer class="footer">
    <div class="container-fluid">
      <p class="copyright">&copy; 2006 HappyPurim LLC All Rights Reserved</p>
      <!-- /.copyright -->

      <div class="footer__nav">
        <a href="#">home</a>
        |
        <a href="#">privacy policy</a>
        |
        <a href="#">terms and conditions</a>
        |
        <a href="#">contact</a>
      </div>
      <!-- /.footer__nav -->
    </div>
    <!-- /.container-fluid -->
  </footer>
  <!-- /.footer -->
</template>
<script>
export default {
  name: "FooterPage",
};
</script>
